function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function _ts_generator(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
import * as FileSystem from "expo-file-system/legacy";
import { launchCameraAsync, launchImageLibraryAsync, requestCameraPermissionsAsync, UIImagePickerPreferredAssetRepresentationMode } from "expo-image-picker";
import { Platform } from "react-native";
import { askAsync } from "./permissionsManager";
export function launchMediaPickerAsync(mode, options) {
    return _launchMediaPickerAsync.apply(this, arguments);
}
function _launchMediaPickerAsync() {
    _launchMediaPickerAsync = _async_to_generator(function(mode, options) {
        var uri, permissionResult;
        return _ts_generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    options = _object_spread({
                        mediaTypes: 'images',
                        allowsEditing: false,
                        quality: 1,
                        preferredAssetRepresentationMode: UIImagePickerPreferredAssetRepresentationMode.Compatible
                    }, options);
                    if (!global.e2e) return [
                        3,
                        4
                    ];
                    uri = 'https://picsum.photos/500';
                    if (!(Platform.OS === 'android')) return [
                        3,
                        2
                    ];
                    // Keep Android E2E uploads independent from external image hosts.
                    uri = "".concat(FileSystem.cacheDirectory, "e2e-profile.png");
                    return [
                        4,
                        FileSystem.writeAsStringAsync(uri, 'iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mNk+A8AAQUBAScY42YAAAAASUVORK5CYII=', {
                            encoding: FileSystem.EncodingType.Base64
                        })
                    ];
                case 1:
                    _state.sent();
                    return [
                        3,
                        3
                    ];
                case 2:
                    if (Platform.OS === 'ios') {
                        // For some reason iOS can't fetch picsum.photos, but android can.
                        // Web can't fetch placedog.net b/c of a CORS issue.
                        uri = 'https://placedog.net/500/500';
                    }
                    _state.label = 3;
                case 3:
                    return [
                        2,
                        Promise.resolve({
                            canceled: false,
                            assets: [
                                {
                                    uri: uri,
                                    width: 500,
                                    height: 500
                                }
                            ]
                        })
                    ];
                case 4:
                    if (mode === 'gallery') {
                        return [
                            2,
                            launchImageLibraryAsync(options)
                        ];
                    }
                    return [
                        4,
                        askAsync('Camera', function() {
                            return requestCameraPermissionsAsync();
                        }, {
                            retryIfDenied: true
                        })
                    ];
                case 5:
                    permissionResult = _state.sent();
                    if (!permissionResult.granted) return [
                        2,
                        {
                            canceled: true,
                            assets: null,
                            denied: true
                        }
                    ];
                    return [
                        2,
                        launchCameraAsync(options)
                    ];
            }
        });
    });
    return _launchMediaPickerAsync.apply(this, arguments);
}
